/**
 * user模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const verify = {
  //验证供应商信息是否正确
    verifyVendor(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH_OPEN}/verify/vendor`, { params: params});
    }
}

export default verify;



// WEBPACK FOOTER //
// ./src/api/verify.js